<template>
  <div>
    <!-- Play button -->
    <button
      class="w-16 h-16 flex bg-white text-black items-center justify-center rounded-full shadow focus:outline-none focus:bg-primary-light"
      @click="onOpenOverlay($event)"
    >
      <span class="icon-play" />
    </button>
  </div>
</template>

<script>
import EventBus from '@/event-bus'

export default {
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  methods: {
    onOpenOverlay(e) {
      e.preventDefault()
      EventBus.$emit('SHOW_VIDEO_OVERLAY', this.video)
    }
  }
}
</script>
